import React from 'react';
import { AlertTriangle, ArrowUpRight, ArrowDownRight, Minus } from 'lucide-react';
const competitors = [{
  name: 'Nexus Corp',
  threat: 'CRITICAL',
  share: '28.5%',
  growth: '+12.4%',
  status: 'Aggressive'
}, {
  name: 'Vortex Systems',
  threat: 'HIGH',
  share: '18.2%',
  growth: '+5.1%',
  status: 'Expanding'
}, {
  name: 'OmniGlobal',
  threat: 'MEDIUM',
  share: '15.0%',
  growth: '-2.3%',
  status: 'Stagnant'
}, {
  name: 'CyberDyne',
  threat: 'LOW',
  share: '8.4%',
  growth: '+1.2%',
  status: 'Stable'
}, {
  name: 'Aegis Inc',
  threat: 'LOW',
  share: '5.1%',
  growth: '-0.5%',
  status: 'Declining'
}, {
  name: 'Zenith Tech',
  threat: 'MEDIUM',
  share: '4.8%',
  growth: '+8.7%',
  status: 'Emerging'
}];
const getThreatColor = (level: string) => {
  switch (level) {
    case 'CRITICAL':
      return 'text-red-500 bg-red-500/10 border-red-500/30';
    case 'HIGH':
      return 'text-orange-500 bg-orange-500/10 border-orange-500/30';
    case 'MEDIUM':
      return 'text-yellow-500 bg-yellow-500/10 border-yellow-500/30';
    case 'LOW':
      return 'text-green-500 bg-green-500/10 border-green-500/30';
    default:
      return 'text-slate-500';
  }
};
const getGrowthIcon = (growth: string) => {
  if (growth.startsWith('+')) return <ArrowUpRight className="w-4 h-4 text-green-500" data-id="element-8" />;
  if (growth.startsWith('-')) return <ArrowDownRight className="w-4 h-4 text-red-500" data-id="element-9" />;
  return <Minus className="w-4 h-4 text-slate-500" data-id="element-10" />;
};
export function CompetitorTable() {
  return <section className="py-24 bg-[#0d1f35] border-y border-slate-800" data-id="element-11">
      <div className="container mx-auto px-4" data-id="element-12">
        <div className="flex flex-col md:flex-row justify-between items-end mb-8 gap-4" data-id="element-13">
          <div data-id="element-14">
            <h2 className="text-3xl font-bold mb-2" data-id="element-15">THREAT MATRIX</h2>
            <p className="text-slate-400" data-id="element-16">
              Live surveillance of key market adversaries
            </p>
          </div>
          <div className="text-[#00d4ff] font-mono text-sm animate-pulse" data-id="element-17">
            ● LIVE FEED ACTIVE
          </div>
        </div>

        <div className="overflow-x-auto bg-[#1a2942] rounded-lg border border-slate-700 shadow-xl" data-id="element-18">
          <table className="w-full text-left border-collapse" data-id="element-19">
            <thead data-id="element-20">
              <tr className="bg-[#0a1628] border-b border-slate-700 text-slate-400 text-sm uppercase font-mono" data-id="element-21">
                <th className="p-4 font-medium" data-id="element-22">Company Entity</th>
                <th className="p-4 font-medium" data-id="element-23">Threat Level</th>
                <th className="p-4 font-medium" data-id="element-24">Market Share</th>
                <th className="p-4 font-medium" data-id="element-25">Growth (YoY)</th>
                <th className="p-4 font-medium" data-id="element-26">Current Status</th>
                <th className="p-4 font-medium text-right" data-id="element-27">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-700" data-id="element-28">
              {competitors.map((comp, idx) => <tr key={idx} className="hover:bg-[#00d4ff]/5 transition-colors group" data-id="element-29">
                  <td className="p-4 font-bold text-white group-hover:text-[#00d4ff] transition-colors" data-id="element-30">
                    {comp.name}
                  </td>
                  <td className="p-4" data-id="element-31">
                    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded border text-xs font-bold font-mono ${getThreatColor(comp.threat)}`} data-id="element-32">
                      {comp.threat === 'CRITICAL' && <AlertTriangle className="w-3 h-3" data-id="element-33" />}
                      {comp.threat}
                    </span>
                  </td>
                  <td className="p-4 font-mono text-slate-300" data-id="element-34">{comp.share}</td>
                  <td className="p-4 font-mono text-slate-300 flex items-center gap-2" data-id="element-35">
                    {getGrowthIcon(comp.growth)}
                    {comp.growth}
                  </td>
                  <td className="p-4 text-slate-300 text-sm" data-id="element-36">{comp.status}</td>
                  <td className="p-4 text-right" data-id="element-37">
                    <button className="text-[#00d4ff] hover:text-white text-xs font-mono uppercase tracking-wider hover:underline" data-id="element-38">
                      Analyze &rarr;
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}